<template>
    <div class="explicit-photo-placeholder">
        <div class="explicit-photo-placeholder-content">

            <div class="explicit-photo-placeholder-inner">
                <ExplicitIconComponent :class="['explicit-photo-icon', {'mb-0 small': !showActionButtons}]" />

                <template v-if="showActionButtons">
                    <span class="explicit-photo-heading">{{ translate.home.fsk18Content }}</span>

                    <button class="btn unlock-explicit-content-button" v-if="!currentUser"
                            @click.prevent.stop="trackAndShowLoginModal"
                            e2e-id="btn-unlock-explicit-content-register">
                        {{ translate.home.singIn }}
                    </button>

                    <button class="btn unlock-explicit-content-button" v-else-if="currentUser && isPunter && !isAgeVerified"
                            @click.prevent.stop="trackAndVerifyAge"
                            e2e-id="btn-unlock-explicit-content-validate-age">
                        {{ translate.account.validateAgeToViewExplicit }}
                    </button>

                    <button class="btn unlock-explicit-content-button" v-else-if="currentUser && isPunter && !isVipPunter && currentUser.allowed_explicit_photo"
                            @click="navigateToBuyPremium">
                        {{ translate.account.buyVipPunter }}
                    </button>

                    <button class="btn unlock-explicit-content-button" v-else-if="currentUser && isPunter && !isVipPunter && !currentUser.allowed_explicit_photo"
                            @click.prevent.stop="unlockExplicitPhoto"
                            e2e-id="btn-unlock-explicit-content-validate-age">
                        {{ translate.account.selectToUnlockExplicit }}
                    </button>
                </template>
            </div>

            <div class="explicit-photo-blur-bg"></div>

        </div>
    </div>
</template>

<script>

import ageVerificationMixin from "@/components/mixins/ageVerificationMixin";
import userMixin from "@/components/mixins/userMixin";
import xtrackingMixin from '@/components/mixins/xtrackingMixin';
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import ExplicitIconComponent from "@/components/global/icons/ExplicitIconComponent.vue";

function trackAndVerifyAge() {
    this.trackAgeVerification();
    this.verifyAge();
}

async function unlockExplicitPhoto() {
    const [err, response] = await to(
        api.user.unlockExplicitUser(this.profileUserId)
    );

    if (err) {
        toastr.error(this.translate.home.errorCommon);
    }

    const success = _.get(response, 'data.success');

    if (success) {
        const _user = _.cloneDeep(this.currentUser);
        _user.allowed_explicit_photo = this.profileUserId;

        $store.commit('setCurrentUser', _user);
    } else {
        toastr.error(this.translate.home.errorCommon);
    }
}

function trackAndShowLoginModal() {
    this.trackAgeVerification();
    this.showLoginModal();
}


function trackAgeVerification() {

    let category = null;
    let action = null;

    if (this.verificationOrigin === 'search' && this.currentUser) {
        category = 'search_results';
        action = 'explicit_photo_age_verification';
    }

    if (this.verificationOrigin === 'search' && !this.currentUser) {
        category = 'search_results';
        action = 'explicit_photo_registration';
    }

    if (this.verificationOrigin === 'gallery' && this.currentUser) {
        category = 'profile';
        action = 'explicit_photo_age_verification';
    }

    if (this.verificationOrigin === 'gallery' && !this.currentUser) {
        category = 'profile';
        action = 'explicit_photo_registration';
    }

    if (category && action) {
        this.captureTrackingEvent(this.currentUser, category, action, 'click', this.profileUserId);
    }
}

function showLoginModal() {
    $('#modalNotLoggedIn').modal('show');
}

function navigateToBuyPremium() {
    window.location.href = regionRelativeUrl('/users/products/punter-vip');
}

export default {
    components: {
        ExplicitIconComponent,
    },
    computed: {
        ...mapState(['currentUser', 'translate']),
    },
    mixins: [
        ageVerificationMixin,
        userMixin,
        xtrackingMixin
    ],
    methods: {
        showLoginModal,
        trackAgeVerification,
        trackAndVerifyAge,
        unlockExplicitPhoto,
        trackAndShowLoginModal,
        navigateToBuyPremium,
    },
    props: {
        profileUserId: {
            type: Number
        },
        verificationOrigin: {
            type: String
        },
        isVideo: {
            type: Boolean,
            default: false
        },
        showActionButtons: {
            type: Boolean,
            default: true
        },
    }
}
</script>
